module.exports = __webpack_public_path__ + "img/35.ea72f70a.png";